//baseUrl
const DOMAIN_NAME = {
  // URL_EASYMOCK: 'http://192.168.5.120:6813' // 内部测试服
  // URL_EASYMOCK: 'http://123.57.57.143:6813' // 外部测试服
  URL_EASYMOCK: 'https://zgsfxg.com'
}

export default DOMAIN_NAME



// WEBPACK FOOTER //
// ./src/server/config.js